<script lang="ts" setup>
import { QTree } from 'quasar'
import { $t } from '../../composables/i18n'
import PDivider from '../divider/PDivider.vue'
import { PSpaceSize } from '../space/types'
import PTextFormBody from '../typography/form/PTextFormBody.vue'
import PSpace from '../space/PSpace.vue'
import type { PNode } from './types'

type Props = {
  nodes: PNode[]
  emptyText?: string
  allowMultipleNodeExpansion?: boolean
  collapseAll?: boolean
}

const model = defineModel<number[]>({ default: [] })
withDefaults(defineProps<Props>(), {
  emptyText: $t('No results'),
  allowMultipleNodeExpansion: false,
  collapseAll: false,
})

const onClick = (node: PNode) => {
  if (node.children) {
    return
  }

  if (model.value.includes(node.id)) {
    model.value = model.value.filter((val) => val !== node.id)
    return
  }

  model.value = [...model.value, node.id]
}
</script>

<template>
  <q-tree
    v-model:ticked="model"
    :nodes="nodes"
    :no-nodes-label="emptyText"
    :accordion="!allowMultipleNodeExpansion"
    :default-expand-all="!collapseAll"
    node-key="id"
    tick-strategy="leaf"
    icon="fa-light fa-chevron-right"
    no-connectors
  >
    <template #default-header="arg">
      <div class="p-full-width">
        <div class="p-flex p-cursor-pointer p-non-selectable" @click="onClick(arg.node)">
          <p-space :mobile="PSpaceSize.MD" />
          <p-text-form-body :text="arg.node.name" />
        </div>

        <p-divider />
      </div>
    </template>
  </q-tree>
</template>
